import { allApiModules, buildApiClient } from '@mi-front/core';
import { config } from '../config';

export const apiClient = buildApiClient(
  {
    apiRoot: config.apiRoot,
  },
  allApiModules,
);

// setKubbApiClient(apiClient);
